import { render, staticRenderFns } from "./OrderFeeDialog.vue?vue&type=template&id=755fb4aa&"
import script from "./OrderFeeDialog.vue?vue&type=script&lang=js&"
export * from "./OrderFeeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports